window.price =
{
    asyncPrice: async function ()
    {
        var elements = document.querySelectorAll(".async-price");

        if (elements.length == 0)
            return;

        var productIds = [];
        var quantityUnits = [];

        elements.forEach(element =>
        {
            var index = productIds.indexOf(element.dataset.productId);

            // přeskočení identických produktů s identickými jednotkami
            if (index > -1 && quantityUnits[index] == element.dataset.quantityUnit)
                return;

            productIds.push(element.dataset.productId);
            quantityUnits.push(element.dataset.quantityUnit);
        });

        var stringProductIds = productIds.join(",");
        var stringQuantityUnits = quantityUnits.join(",");

        var data = null;

        try
        {
            var response = await fetch(`${document.baseURI}api/price?productIds=${stringProductIds}&quantityUnits=${stringQuantityUnits}`);

            data = await response.json();
        }
        catch (error)
        {
            console.error(error);

            return;
        }

        elements.forEach(element =>
        {
            var productId = element.dataset.productId;
            var quantityUnit = element.dataset.quantityUnit;

            var isVatPrice = element.dataset.vatPrice === "True";

            var item = data.filter(x => x.productId == productId)[0];
            var price = isVatPrice ? item.priceWithVAT : item.price;

            element.outerHTML = price;

            var customEvent = new CustomEvent("onPriceLoaded", { detail: { data: item, isVatPrice: isVatPrice } });

            document.dispatchEvent(customEvent);
        });
    },
    load: function ()
    {
        price.asyncPrice();
        price.quantityDiscounts();
        price.tieredPrices();
    },
    quantityDiscounts: async function ()
    {
        var element = document.querySelector(".async-quantity-discounts");

        if (!element)
            return;

        var data = null;

        try
        {
            var response = await fetch(`${document.baseURI}product/getquantitydiscounts?productId=${element.dataset.productId}&quantityUnit=${element.dataset.quantityUnit}`);

            data = await response.text();
        }
        catch (error)
        {
            console.error(error);

            return;
        }

        element.outerHTML = data;
    },
    tieredPrices: async function ()
    {
        var element = document.querySelector(".async-tiered-prices");

        if (!element)
            return;

        var data = null;

        try
        {
            var response = await fetch(`${document.baseURI}product/gettieredprices?productId=${element.dataset.productId}&quantityUnit=${element.dataset.quantityUnit}`);

            data = await response.text();
        }
        catch (error)
        {
            console.error(error);

            return;
        }

        element.outerHTML = data;
    }
};